// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"bc1cc25b","162":"455b9d73","453":"491f8616","739":"f241087b"}[chunkId] + ".chunk.js";
};